import { WIDGETS_API_VERSION } from "./constants.js";

export function getAuthHeaders(authToken?: string): HeadersInit {
  if (!authToken) {
    return {
      "WorkOS-Widgets-Version": WIDGETS_API_VERSION,
    };
  }

  return {
    Authorization: `Bearer ${authToken}`,
    "WorkOS-Widgets-Version": WIDGETS_API_VERSION,
  };
}

export function isObjectLike(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function isErrorLike(
  value: unknown,
): value is Record<string, unknown> & { message: string } {
  return isObjectLike(value) && typeof value.message === "string";
}

export async function parseErrorResponse(
  response: Response,
): Promise<{ message: string; status: number }> {
  try {
    const json = await response.json();
    if (!isObjectLike(json) || typeof json.message !== "string") {
      return {
        status: response.status,
        message: response.statusText,
      };
    }
    return {
      ...json,
      status: response.status,
      message: json.message || response.statusText,
    };
  } catch {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

type Claims = {
  sid: string;
  permissions?: string[];
  exp?: number;
};

export function getClaims(accessToken: string): Claims {
  return JSON.parse(atob(accessToken.split(".")[1]));
}
